import { isString, inList } from './operators/helpers';
import { sanitizeTextBlock } from './operators/sanitizeTextBlock';
import { sanitizeText } from './operators/sanitizeText';
import { sanitizeButton } from './operators/sanitizeButton';
import { sanitizeInput } from './operators/sanitizeInput';
import { sanitizeSelect } from './operators/sanitizeSelect';
import { sanitizeSlotList } from './operators/sanitizeSlotList';
import { sanitizeCalendar } from './operators/sanitizeCalendar';
import { sanitizeStack } from './operators/sanitizeStack';
import { sanitizeRow } from './operators/sanitizeRow';
import { sanitizeTextarea } from './operators/sanitizeTextarea';
import { sanitizeCheckbox } from './operators/sanitizeCheckbox';
import { sanitizeIf } from './operators/sanitizeIf';
import { sanitizeLoop } from './operators/sanitizeLoop';
import { sanitizeTimezonePicker } from './operators/sanitizeTimezonePicker';
import { sanitizeOptionButton } from './operators/sanitizeOptionButton';
import { sanitizeIcon } from './operators/sanitizeIcon';
import { sanitizeSvgIcon } from './operators/sanitizeSvgIcon';
import { sanitizeAutoColumns } from './operators/sanitizeAutoColumns';
const ALLOWED_TYPES = ['Icon', 'SvgIcon', 'TextBlock', 'Text', 'Button', 'OptionButton', 'Input', 'Textarea', 'Checkbox', 'Select', 'SlotList', 'Calendar', 'TimezonePicker', 'Stack', 'Row', 'AutoColumns', 'If', 'Loop'];
function sanitizeElementWith(element, recurse) {
  if (!element || typeof element !== 'object') {
    return null;
  }
  const el = element;
  if (!isString(el.type) || !inList(ALLOWED_TYPES, el.type)) {
    return null;
  }
  switch (el.type) {
    case 'Icon':
      return sanitizeIcon(el);
    case 'SvgIcon':
      return sanitizeSvgIcon(el);
    case 'TextBlock':
      return sanitizeTextBlock(el);
    case 'Text':
      return sanitizeText(el);
    case 'Button':
      return sanitizeButton(el, recurse);
    case 'Input':
      return sanitizeInput(el);
    case 'Select':
      return sanitizeSelect(el);
    case 'SlotList':
      return sanitizeSlotList(el);
    case 'Calendar':
      return sanitizeCalendar(el);
    case 'OptionButton':
      return sanitizeOptionButton(el);
    case 'TimezonePicker':
      return sanitizeTimezonePicker(el);
    case 'Stack':
      return sanitizeStack(el, recurse);
    case 'Row':
      return sanitizeRow(el, recurse);
    case 'AutoColumns':
      return sanitizeAutoColumns(el, recurse);
    case 'Textarea':
      return sanitizeTextarea(el);
    case 'Checkbox':
      return sanitizeCheckbox(el);
    case 'If':
      return sanitizeIf(el, recurse);
    case 'Loop':
      return sanitizeLoop(el, sanitizeElementForbiddingLoop);
    default:
      return null;
  }
}
function sanitizeElementForbiddingLoop(element) {
  if (element && typeof element === 'object' && element.type === 'Loop') {
    return null;
  }
  return sanitizeElementWith(element, sanitizeElementForbiddingLoop);
}
export function sanitizeElement(element) {
  return sanitizeElementWith(element, sanitizeElement);
}
export function sanitizeCardBody(body) {
  if (!Array.isArray(body)) {
    return null;
  }
  const sanitized = body.map(sanitizeElement).filter(el => el !== null);
  return sanitized.length > 0 ? sanitized : null;
}